import Styles from './WordPressInitialization.module.scss'

const STEP_ONE_IMAGE =
  'https://res.cloudinary.com/almanac/image/upload/v1722961294/blaze_assets/wordpress_instructions/step1_akmgsr.png'

const STEP_TWO_IMAGE =
  'https://res.cloudinary.com/almanac/image/upload/v1722961335/blaze_assets/wordpress_instructions/step2_qzmack.png'

const STEP_THREE_IMAGE =
  'https://res.cloudinary.com/almanac/image/upload/v1722961390/blaze_assets/wordpress_instructions/step3_hqym2k.png'

const STEP_FOUR_IMAGE =
  'https://res.cloudinary.com/almanac/image/upload/v1722961390/blaze_assets/wordpress_instructions/step4_sfrgjw.png'

export const InstallationInstructions = () => (
  <div className={Styles.installationInstructions}>
    <ul>
      <li>
        <p>
          Navigate to your WordPress admin panel (usually at https://your-wp-site.com/wp-admin). Navigate to "Plugins"
          on the left navigation bar.
        </p>
        <img src={STEP_ONE_IMAGE} alt="Step 1" className={Styles.fullWidth} />
      </li>
      <li>
        <p>Click on "Add New Plugin" at the top of the page, then click "Upload Plugin"</p>
        <img src={STEP_TWO_IMAGE} alt="Step 2" />
      </li>
      <li>
        <p>Upload the zipped plugin you downloaded earlier, then click "Install Now"</p>
        <img src={STEP_THREE_IMAGE} alt="Step 3" className={Styles.fullWidth} />
      </li>
      <li>
        <p>Click the "Activate Plugin" button to activate Blaze and complete the installation process.</p>
        <img src={STEP_FOUR_IMAGE} alt="Step 4" />
      </li>
    </ul>
  </div>
)
